<template>
  <div class="header__container header__container--no-navigation">
    <div class="nav__logo">
      <div class="unlink-logo">
        <img
          v-lazy="noNavigationLogoImage"
          alt="no-navigation-logo"
          class="nav-button--logo"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    noNavigationLogoImage: {
      type: String,
      required: true
    }
  }
}
</script>
